import { FetchError } from "@xompass/web-sdk";

const AUTH_RETRY_DELAY_MS = 1000;

export async function loadWithAuthRetry<T>(
  label: string,
  load: () => Promise<T>,
): Promise<T> {
  try {
    return await load();
  } catch (error) {
    if (!(error instanceof FetchError) || error.status !== 401) {
      throw error;
    }

    console.warn(`Unauthorized ${label} access`);
    await new Promise((resolve) => setTimeout(resolve, AUTH_RETRY_DELAY_MS));
    console.warn(`Retrying ${label} load`);
    return load();
  }
}
